import request from "@/utils/request/request";

export function receiveCourse(name: string, mobile: string) {
  return request.postObject("ec/api/add", {
    name: name,
    mobile: mobile,
  });
}
